import { Directive } from '@angular/core';

@Directive({
    selector: '[facet-slot],f-facet[name=slot]',
    host: {
        '[class.b-view-panel__slot]': 'true'
    },
    standalone: false
})
export class FacetSlotDirective {}
